// In-memory token store — never persisted to localStorage to reduce XSS risk.
// sessionStorage is used only for tab-level persistence on reload.

let _accessToken: string | null = null;

export const setToken = (token: string | null): void => {
  _accessToken = token;
  if (token) {
    sessionStorage.setItem("access_token", token);
  } else {
    sessionStorage.removeItem("access_token");
  }
};

/** Returns the token from memory, falling back to sessionStorage on cold load. */
export const getToken = (): string | null => {
  if (_accessToken) return _accessToken;
  const stored = sessionStorage.getItem("access_token");
  if (stored) {
    _accessToken = stored;
    return _accessToken;
  }
  return null;
};

export const getAuthHeader = (): Record<string, string> => {
  const token = getToken();
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const clearToken = (): void => {
  _accessToken = null;
  sessionStorage.removeItem("access_token");
};
